import { Box, Textarea, RadioGroup, Radio } from "@chakra-ui/react";
import { Control, UseFormSetValue } from "react-hook-form";
import { Row, Col } from "antd";
import Field from "components/Input/Field/index";
import OutlineButton from "components/Button/OutlineButton";
import { Divider } from "@chakra-ui/layout";
import { BsPlusLg } from "react-icons/bs";
import TableItensFornecedor from "./TableItensFornecedor/index";
import { useState } from "react";
import { OrcamentoCotacaoItemForm } from "features/orcamento/typings";
import ModalAdicionarItem from "../ModalAdicionarItem/index";
import InputMoney from "components/Input/InputMoney/index";
import SelectFormaPagamento from "components/Input/SelectFormaPagamento";
import AnexarArquivos from "../ModalDetalhesCotacao/components/AnexarArquivos/index";

export default function FormCotacao({
  control,
  form,
  setValue,
  orcamentoId,
  setArquivosExcluidos,
}: {
  control: Control<OrcamentoCotacaoItemForm, any>;
  form: OrcamentoCotacaoItemForm;
  setValue: UseFormSetValue<OrcamentoCotacaoItemForm>;
  orcamentoId?: string;
  setArquivosExcluidos: React.Dispatch<React.SetStateAction<string[]>>;
}) {
  const [openModalAdicionarItem, setOpenModalAdicionarItem] = useState(false);

  return (
    <Box>
      <Box as={Row} gutter={32} mb={6}>
        <Box as={Col} xs={12}>
          <Field
            control={control}
            name="nomeFornecedor"
            label="Nome do fornecedor"
            rules={{ required: true }}
          />
        </Box>
        <Box as={Col} xs={6}>
          <Field
            control={control}
            name="contato"
            label="Telefone"
            inputProps={{ type: "phone" }}
          />
        </Box>
        <Box as={Col} xs={6}>
          <Field
            control={control}
            name="email"
            label="Email"
            inputProps={{ type: "email", placeholder: "seuemail@email.com" }}
          />
        </Box>
      </Box>
      <Box as={Row} gutter={32} mb={6}>
        <Box as={Col} xs={6}>
          <Field
            control={control}
            name="dataCotacao"
            label="Data da cotação"
            inputProps={{ type: "date" }}
            rules={{ required: true }}
          />
        </Box>
        <Box as={Col} xs={6}>
          <Field
            control={control}
            name="dataValidade"
            label="Valido até"
            inputProps={{ type: "date" }}
            rules={{ required: true }}
          />
        </Box>
        <Box as={Col} xs={6}>
          <Field
            control={control}
            name="formaPagamentoId"
            label="Forma de pagamento"
            render={({ field }) => <SelectFormaPagamento {...field} />}
          />
        </Box>

        <Box as={Col} xs={6}>
          <Field
            control={control}
            name="prazoEntregaDias"
            label="Prazo de entrega (dias)"
            render={({ field, isInvalid }) => (
              <InputMoney
                {...field}
                isInvalid={isInvalid}
                allowDecimals={false}
                decimalScale={0}
                allowNegativeValue={false}
                step={1}
                placeholder="0"
              />
            )}
          />
        </Box>
      </Box>
      <Box as={Row} gutter={32} mb={6}>
        <Box as={Col} xs={24}>
          <Field
            control={control}
            name="observacao"
            label="Observação"
            render={({ field, isInvalid }) => (
              <Textarea
                isInvalid={isInvalid}
                className="chakra-input"
                rows={4}
                resize="none"
                placeholder="Digite..."
                {...field}
              />
            )}
          />
        </Box>
      </Box>

      <Box as={Row} gutter={32} mb={6}>
        <Box as={Col} xs={24}>
          <AnexarArquivos
            control={control}
            form={form}
            setValue={setValue as any}
            pushArquivoRemovido={(id) =>
              setArquivosExcluidos((state) => [...state, id])
            }
          />
        </Box>
      </Box>

      <Divider my={4} />

      <Box as={Row} gutter={32}>
        <Box as={Col} xs={24}>
          <Field
            control={control}
            name="valorTipo"
            rules={{
              required: true,
            }}
            render={({ field, isInvalid }) => (
              <RadioGroup
                value={field.value}
                onChange={field.onChange}
                as={Row}
                gutter={32}
                mb={6}
              >
                <Box as={Col} md={6}>
                  <Radio
                    isInvalid={isInvalid}
                    color={isInvalid ? "red" : undefined}
                    value={"individual"}
                  >
                    Informar valor individual dos itens
                  </Radio>
                </Box>
                <Box as={Col} md={8}>
                  <Radio
                    isInvalid={isInvalid}
                    color={isInvalid ? "red" : undefined}
                    value={"total"}
                  >
                    Informar um valor total do orçamento
                  </Radio>
                </Box>
              </RadioGroup>
            )}
          />
        </Box>
      </Box>

      {form.valorTipo === "individual" ? (
        <>
          <OutlineButton onClick={() => setOpenModalAdicionarItem(true)} mb={4}>
            <BsPlusLg />
            Adicionar item
          </OutlineButton>

          <TableItensFornecedor
            orcamentoId={orcamentoId}
            form={form}
            control={control}
          />

          {openModalAdicionarItem ? (
            <ModalAdicionarItem
              orcamentoId={orcamentoId}
              isOpenModal={openModalAdicionarItem}
              onClose={() => {
                setOpenModalAdicionarItem(false);
              }}
              onSaved={(item) => {
                const items = form.orcamentoCotacaoItems;

                const newItems = items?.length ? items.concat(item) : [item];

                setValue("orcamentoCotacaoItems", newItems);

                setOpenModalAdicionarItem(false);
              }}
            />
          ) : null}
        </>
      ) : (
        <Box as={Row} mb={6}>
          <Box as={Col} xs={6}>
            <Field
              control={control}
              shouldUnregister
              name="valorTotal"
              label="Valor total"
              render={({ field, isInvalid }) => (
                <InputMoney
                  isInvalid={isInvalid}
                  value={field.value}
                  onChange={field.onChange}
                />
              )}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
}
